import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';

interface Props {
  onClose: () => void;
  onViewUpdatesClick: () => void;
  visible: boolean;
}

export const PlatformVersionUpgradeAlert = ({ onClose, onViewUpdatesClick, visible }: Props) => {
  if (!visible) {
    return null;
  }

  return (
    <Alert
      action={
        <Stack alignItems="center" direction="row">
          <Button onClick={onViewUpdatesClick} variant="text">
            View updates
          </Button>
          <IconButton aria-label="close" color="inherit" onClick={onClose} size="small">
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Stack>
      }
      color="info"
      severity="info"
      sx={{
        '&.MuiPaper-root .MuiAlert-action': {
          alignItems: 'flex-start',
        },
        bottom: '24px',
        position: 'fixed',
        right: '24px',
      }}
      variant="filled"
    >
      <AlertTitle>CloudQuery Platform has new updates</AlertTitle>
      We`ve added improvements to enhance your experience. See what`s changed.
    </Alert>
  );
};
